"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteSubscription = exports.defineChildren = exports["default"] = exports.completeFlow = exports.completeFilePreload = exports.addSubscription = exports.addAjax = void 0;
exports.getMetricsData = getMetricsData;
exports.getProgressData = getProgressData;
exports.waitForResultSaved = exports.updateSettings = exports.updateSavedProgress = exports.updateSavedAnswers = exports.updatePageFirstElement = exports.updateFilePreloadProgress = exports.updateAnswers = exports.updateAnswer = exports.unsetPlayingAction = exports.unsetLoadingState = exports.switchFeedbackMode = exports.startFilePreloadProgress = exports.showCompleteMessage = exports.showBadConnectionMessage = exports.setWaitingForAjax = exports.setValidationErrors = exports.setToStorage = exports.setStartedProgress = exports.setResponseSet = exports.setPreviewList = exports.setPreloadingAssetsProgress = exports.setPlayingParentId = exports.setPlayingAction = exports.setPawnId = exports.setPawnHash = exports.setParameters = exports.setPageStartedTime = exports.setMetricsValues = exports.setLoadingState = exports.setList = exports.setIsPresenterMode = exports.setFlowId = exports.setFinishedProgress = exports.setEnableAudioWithoutSave = exports.setEnableAudio = exports.setDynamicUserListsValues = exports.setDynamicDataValues = exports.setAudioReady = exports.setAnswerError = exports.setAccommodations = exports.saveStateAndMetrics = exports.saveResult = exports.saveMetricsOnUnload = exports.saveAndGoToPrevPage = exports.saveAndGoToNextPage = exports.saveAndGoToComponent = exports.resetAnswers = exports.resetAll = exports.resetActions = exports.removeAjax = exports.registerAction = exports.preloadAndGoToNextPage = exports.loadFlow = exports.initialState = exports.goToPrevPage = exports.goToNextPage = void 0;
var _reduxActions = require("redux-actions");
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _dropWhile2 = _interopRequireDefault(require("lodash/dropWhile"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _builder = require("./builder.js");
var _player = require("../selectors/player.js");
var _allElements = _interopRequireDefault(require("../allElements.js"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _helpers = require("../other/helpers.js");
var _cccisdPreload = _interopRequireDefault(require("cccisd-preload"));
var _config = _interopRequireDefault(require("../config.js"));
var _browser = require("@sentry/browser");
var _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var allElementsObject = _allElements["default"].reduce(function (obj, element) {
  obj[element.code] = element;
  return obj;
}, {});
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var ajaxCount = 0;
var noNetworkRequst = 'No Network Request';

// Initial state
var initialState = exports.initialState = {
  isCompleted: false,
  isCompleteMessage: false,
  loading: false,
  waitingForAjax: false,
  list: {},
  rootId: 0,
  settings: {},
  answers: {},
  savedAnswers: {},
  progress: {},
  savedProgress: {},
  errors: {},
  showValidationErrors: false,
  pageFirstElementId: 0,
  pageHistory: [],
  actions: [],
  playingAction: [],
  playingParentId: 0,
  parameters: {},
  accommodations: {},
  flowId: 0,
  pawnId: 0,
  pawnHash: '',
  responseSet: 0,
  pageStartedTime: 0,
  storage: {},
  subscriptions: {},
  isAudioReady: true,
  enableAudio: true,
  ajax: [],
  hasBadConnection: false,
  badConnectionInfo: {},
  elementsNumberToPreloadAssets: 10,
  preloadedAssets: [],
  preloadingAssetsProgress: 100,
  dynamicDataValues: {},
  dynamicUserListsValues: {},
  metricsValues: {},
  isFeedbackMode: false,
  isPresenterMode: false,
  allElements: _allElements["default"],
  config: _config["default"]
};

// Actions
var SET_LOADING_STATE = 'flow/player/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'flow/player/UNSET_LOADING_STATE';
var SET_WAITING_FOR_AJAX = 'flow/player/SET_WAITING_FOR_AJAX';
var RESET_ALL = 'flow/player/RESET_ALL';
var UPDATE_SETTINGS = 'flow/player/UPDATE_SETTINGS';
var SET_LIST = 'flow/player/SET_LIST';
var UPDATE_ANSWER = 'flow/player/UPDATE_ANSWER';
var UPDATE_ANSWERS = 'flow/player/UPDATE_ANSWERS';
var SET_ANSWER_ERROR = 'flow/player/SET_ANSWER_ERROR';
var UPDATE_SAVED_ANSWERS = 'flow/player/UPDATE_SAVED_ANSWERS';
var UPDATE_SAVED_PROGRESS = 'flow/player/UPDATE_SAVED_PROGRESS';
var RESET_ANSWERS = 'flow/player/RESET_ANSWERS';
var UPDATE_PAGE_FIRST_ELEMENT = 'flow/player/UPDATE_PAGE_FIRST_ELEMENT';
var SET_VALIDATION_ERRORS = 'flow/player/SET_VALIDATION_ERRORS';
var GO_TO_NEXT_PAGE = 'flow/player/GO_TO_NEXT_PAGE';
var GO_TO_PREV_PAGE = 'flow/player/GO_TO_PREV_PAGE';
var RESET_ACTIONS = 'flow/player/RESET_ACTIONS';
var COMPLETE_FLOW = 'flow/player/COMPLETE_FLOW';
var SHOW_COMPLETE_MESSAGE = 'flow/player/SHOW_COMPLETE_MESSAGE';
var SET_PREVIEW_LIST = 'flow/player/SET_PREVIEW_LIST';
var REGISTER_ACTION = 'flow/player/REGISTER_ACTION';
var SET_PLAYING_PARENT_ID = 'flow/player/SET_PLAYING_PARENT_ID';
var SET_PARAMETERS = 'flow/player/SET_PARAMETERS';
var SET_ACCOMMODATIONS = 'flow/player/SET_ACCOMMODATIONS';
var SET_FLOW_ID = 'flow/player/SET_FLOW_ID';
var SET_PAWN_ID = 'flow/player/SET_PAWN_ID';
var SET_PAWN_HASH = 'flow/player/SET_PAWN_HASH';
var SET_RESPONSE_SET = 'flow/player/SET_RESPONSE_SET';
var SET_STARTED_PROGRESS = 'flow/player/SET_STARTED_PROGRESS';
var SET_FINISHED_PROGRESS = 'flow/player/SET_FINISHED_PROGRESS';
var SET_PAGE_STARTED_TIME = 'flow/player/SET_PAGE_STARTED_TIME';
var SET_TO_STORAGE = 'flow/player/SET_TO_STORAGE';
var ADD_SUBSCRIPTION = 'flow/player/ADD_SUBSCRIPTION';
var DELETE_SUBSCRIPTION = 'flow/player/DELETE_SUBSCRIPTION';
var SET_PLAYING_ACTION = 'flow/player/SET_PLAYING_ACTION';
var UNSET_PLAYING_ACTION = 'flow/player/UNSET_PLAYING_ACTION';
var SET_ENABLE_AUDIO = 'flow/player/SET_ENABLE_AUDIO';
var SET_IS_PRESENTER_MODE = 'flow/player/SET_IS_PRESENTER_MODE';
var SET_AUDIO_READY = 'flow/player/SET_AUDIO_READY';
var ADD_AJAX = 'flow/player/ADD_AJAX';
var REMOVE_AJAX = 'flow/player/REMOVE_AJAX';
var SHOW_BAD_CONNECTION_MESSAGE = 'flow/player/SHOW_BAD_CONNECTION_MESSAGE';
var START_FILE_PRELOAD_PROGRESS = 'flow/player/START_FILE_PRELOAD_PROGRESS';
var UPDATE_FILE_PRELOAD_PROGRESS = 'flow/player/UPDATE_FILE_PRELOAD_PROGRESS';
var COMPLETE_FILE_PRELOAD = 'flow/player/COMPLETE_FILE_PRELOAD';
var SET_PRELOADING_ASSETS_PROGRESS = 'flow/player/SET_PRELOADING_ASSETS_PROGRESS';
var SET_DYNAMIC_DATA_VALUES = 'flow/player/SET_DYNAMIC_DATA_VALUES';
var SET_DYNAMIC_USER_LISTS_VALUES = 'flow/player/SET_DYNAMIC_USER_LISTS_VALUES';
var SET_METRICS_VALUES = 'flow/player/SET_METRICS_VALUES';
var SWITCH_FEEDBACK_MODE = 'flow/player/SWITCH_FEEDBACK_MODE';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setWaitingForAjax = exports.setWaitingForAjax = (0, _reduxActions.createAction)(SET_WAITING_FOR_AJAX);
var resetAll = exports.resetAll = (0, _reduxActions.createAction)(RESET_ALL);
var updateSettings = exports.updateSettings = (0, _reduxActions.createAction)(UPDATE_SETTINGS);
var setList = exports.setList = (0, _reduxActions.createAction)(SET_LIST);
var updateAnswer = exports.updateAnswer = (0, _reduxActions.createAction)(UPDATE_ANSWER);
var updateAnswers = exports.updateAnswers = (0, _reduxActions.createAction)(UPDATE_ANSWERS);
var setAnswerError = exports.setAnswerError = (0, _reduxActions.createAction)(SET_ANSWER_ERROR);
var updateSavedAnswers = exports.updateSavedAnswers = (0, _reduxActions.createAction)(UPDATE_SAVED_ANSWERS);
var updateSavedProgress = exports.updateSavedProgress = (0, _reduxActions.createAction)(UPDATE_SAVED_PROGRESS);
var resetAnswers = exports.resetAnswers = (0, _reduxActions.createAction)(RESET_ANSWERS);
var updatePageFirstElement = exports.updatePageFirstElement = (0, _reduxActions.createAction)(UPDATE_PAGE_FIRST_ELEMENT);
var setValidationErrors = exports.setValidationErrors = (0, _reduxActions.createAction)(SET_VALIDATION_ERRORS);
var goToNextPage = exports.goToNextPage = (0, _reduxActions.createAction)(GO_TO_NEXT_PAGE);
var goToPrevPage = exports.goToPrevPage = (0, _reduxActions.createAction)(GO_TO_PREV_PAGE);
var resetActions = exports.resetActions = (0, _reduxActions.createAction)(RESET_ACTIONS);
var completeFlow = exports.completeFlow = (0, _reduxActions.createAction)(COMPLETE_FLOW);
var _showCompleteMessage = exports.showCompleteMessage = (0, _reduxActions.createAction)(SHOW_COMPLETE_MESSAGE);
var setPreviewList = exports.setPreviewList = (0, _reduxActions.createAction)(SET_PREVIEW_LIST);
var registerAction = exports.registerAction = (0, _reduxActions.createAction)(REGISTER_ACTION);
var setPlayingParentId = exports.setPlayingParentId = (0, _reduxActions.createAction)(SET_PLAYING_PARENT_ID);
var setParameters = exports.setParameters = (0, _reduxActions.createAction)(SET_PARAMETERS);
var setAccommodations = exports.setAccommodations = (0, _reduxActions.createAction)(SET_ACCOMMODATIONS);
var setFlowId = exports.setFlowId = (0, _reduxActions.createAction)(SET_FLOW_ID);
var setPawnId = exports.setPawnId = (0, _reduxActions.createAction)(SET_PAWN_ID);
var setPawnHash = exports.setPawnHash = (0, _reduxActions.createAction)(SET_PAWN_HASH);
var setResponseSet = exports.setResponseSet = (0, _reduxActions.createAction)(SET_RESPONSE_SET);
var setStartedProgress = exports.setStartedProgress = (0, _reduxActions.createAction)(SET_STARTED_PROGRESS);
var setFinishedProgress = exports.setFinishedProgress = (0, _reduxActions.createAction)(SET_FINISHED_PROGRESS);
var setPageStartedTime = exports.setPageStartedTime = (0, _reduxActions.createAction)(SET_PAGE_STARTED_TIME);
var setToStorage = exports.setToStorage = (0, _reduxActions.createAction)(SET_TO_STORAGE);
var addSubscription = exports.addSubscription = (0, _reduxActions.createAction)(ADD_SUBSCRIPTION);
var deleteSubscription = exports.deleteSubscription = (0, _reduxActions.createAction)(DELETE_SUBSCRIPTION);
var setPlayingAction = exports.setPlayingAction = (0, _reduxActions.createAction)(SET_PLAYING_ACTION);
var unsetPlayingAction = exports.unsetPlayingAction = (0, _reduxActions.createAction)(UNSET_PLAYING_ACTION);
var setEnableAudioWithoutSave = exports.setEnableAudioWithoutSave = (0, _reduxActions.createAction)(SET_ENABLE_AUDIO);
var setIsPresenterMode = exports.setIsPresenterMode = (0, _reduxActions.createAction)(SET_IS_PRESENTER_MODE);
var setAudioReady = exports.setAudioReady = (0, _reduxActions.createAction)(SET_AUDIO_READY);
var addAjax = exports.addAjax = (0, _reduxActions.createAction)(ADD_AJAX);
var removeAjax = exports.removeAjax = (0, _reduxActions.createAction)(REMOVE_AJAX);
var showBadConnectionMessage = exports.showBadConnectionMessage = (0, _reduxActions.createAction)(SHOW_BAD_CONNECTION_MESSAGE);
var startFilePreloadProgress = exports.startFilePreloadProgress = (0, _reduxActions.createAction)(START_FILE_PRELOAD_PROGRESS);
var updateFilePreloadProgress = exports.updateFilePreloadProgress = (0, _reduxActions.createAction)(UPDATE_FILE_PRELOAD_PROGRESS);
var completeFilePreload = exports.completeFilePreload = (0, _reduxActions.createAction)(COMPLETE_FILE_PRELOAD);
var setPreloadingAssetsProgress = exports.setPreloadingAssetsProgress = (0, _reduxActions.createAction)(SET_PRELOADING_ASSETS_PROGRESS);
var setDynamicDataValues = exports.setDynamicDataValues = (0, _reduxActions.createAction)(SET_DYNAMIC_DATA_VALUES);
var setDynamicUserListsValues = exports.setDynamicUserListsValues = (0, _reduxActions.createAction)(SET_DYNAMIC_USER_LISTS_VALUES);
var setMetricsValues = exports.setMetricsValues = (0, _reduxActions.createAction)(SET_METRICS_VALUES);
var switchFeedbackMode = exports.switchFeedbackMode = (0, _reduxActions.createAction)(SWITCH_FEEDBACK_MODE);
var setEnableAudio = exports.setEnableAudio = function setEnableAudio(enableAudio) {
  var shouldSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var _getState$flow$player, pawnId, pawnHash;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(setEnableAudioWithoutSave(enableAudio));
            if (shouldSave) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _getState$flow$player = getState().flow.player, pawnId = _getState$flow$player.pawnId, pawnHash = _getState$flow$player.pawnHash;
            if (!(!pawnId || !pawnHash)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            _context.next = 8;
            return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
              pawn: pawnId
            }), {
              pawnHash: pawnHash,
              'settings-flow-enableAudio': Boolean(enableAudio)
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var preloadAndGoToNextPage = exports.preloadAndGoToNextPage = function preloadAndGoToNextPage() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var state, assetsToPreload, progress;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState().flow.player; // Preload assets if they haven't been preloaded yet
            assetsToPreload = (0, _player.getNextPageAssetsToPreload)(state);
            if (assetsToPreload.length > 0) {
              dispatch(startFilePreloadProgress(assetsToPreload));
              (0, _cccisdPreload["default"])({
                timeout: 120 * 1000,
                preferXHR: false,
                assets: assetsToPreload,
                onFileProgressUpdate: function onFileProgressUpdate(_ref3) {
                  var url = _ref3.url,
                    progress = _ref3.progress;
                  dispatch(updateFilePreloadProgress({
                    url: url,
                    progress: progress
                  }));
                },
                onFileLoad: function onFileLoad(_ref4) {
                  var url = _ref4.url;
                  dispatch(completeFilePreload(url));
                },
                onFileError: function onFileError(_ref5) {
                  var url = _ref5.url;
                  dispatch(completeFilePreload(url));
                }
              });
            }
            progress = (0, _player.getNextPagePreloadedAssetsProgress)(state);
            if (!(progress < 100)) {
              _context2.next = 8;
              break;
            }
            dispatch(setPreloadingAssetsProgress(progress));
            _context2.next = 8;
            return new Promise(function (resolve) {
              var interval = setInterval(function () {
                var updatedState = getState().flow.player;
                var updatedProgress = (0, _player.getNextPagePreloadedAssetsProgress)(updatedState);
                if (updatedProgress >= 100) {
                  clearInterval(interval);

                  // Just to show the animation that the progress comes to the end
                  dispatch(setPreloadingAssetsProgress(99));
                  setTimeout(function () {
                    dispatch(setPreloadingAssetsProgress(100));
                    resolve();
                  }, 1000);
                } else {
                  dispatch(setPreloadingAssetsProgress(updatedProgress));
                }
              }, 500);
            });
          case 8:
            dispatch(goToNextPage());
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var loadFlow = exports.loadFlow = function loadFlow(_ref6) {
  var flowId = _ref6.flowId,
    _ref6$pawnId = _ref6.pawnId,
    pawnId = _ref6$pawnId === void 0 ? 0 : _ref6$pawnId,
    _ref6$pawnHash = _ref6.pawnHash,
    pawnHash = _ref6$pawnHash === void 0 ? '' : _ref6$pawnHash,
    _ref6$responseSet = _ref6.responseSet,
    responseSet = _ref6$responseSet === void 0 ? 0 : _ref6$responseSet,
    _ref6$withProgress = _ref6.withProgress,
    withProgress = _ref6$withProgress === void 0 ? true : _ref6$withProgress,
    playingParentId = _ref6.playingParentId,
    _ref6$variables = _ref6.variables,
    variables = _ref6$variables === void 0 ? {} : _ref6$variables,
    _ref6$userLists = _ref6.userLists,
    userLists = _ref6$userLists === void 0 ? {} : _ref6$userLists,
    enableAudio = _ref6.enableAudio,
    pageFirstElementId = _ref6.pageFirstElementId,
    _ref6$isPreviewMode = _ref6.isPreviewMode,
    isPreviewMode = _ref6$isPreviewMode === void 0 ? false : _ref6$isPreviewMode,
    _ref6$isPresenterMode = _ref6.isPresenterMode,
    isPresenterMode = _ref6$isPresenterMode === void 0 ? false : _ref6$isPresenterMode;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var response, res, attributes, rootId, flowUpdatedAt, settings, stateUpdatedAt, treeUpdatedAt, dataConnectorsVariableIds, _response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(resetAll());
            dispatch(setLoadingState());
            dispatch(setFlowId(flowId));
            dispatch(setPawnId(pawnId));
            dispatch(setPawnHash(pawnHash));
            dispatch(setResponseSet(responseSet));
            dispatch(setDynamicDataValues(variables));
            dispatch(setDynamicUserListsValues(userLists));
            dispatch(setIsPresenterMode(isPresenterMode));
            if (!(typeof enableAudio !== 'undefined')) {
              _context3.next = 13;
              break;
            }
            dispatch(setEnableAudio(enableAudio));
            _context3.next = 19;
            break;
          case 13:
            if (!(pawnId && pawnHash)) {
              _context3.next = 19;
              break;
            }
            _context3.next = 16;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.pawn.show', {
              pawnId: pawnId,
              pawnHash: pawnHash
            }));
          case 16:
            response = _context3.sent;
            enableAudio = (0, _get2["default"])(response, 'data.data.settings.flow.enableAudio');
            if (typeof enableAudio !== 'undefined') {
              dispatch(setEnableAudio(enableAudio, false));
            }
          case 19:
            _context3.next = 21;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.show', {
              flow: flowId
            }));
          case 21:
            res = _context3.sent;
            attributes = res.data.data.attributes;
            rootId = attributes.root_id;
            flowUpdatedAt = attributes.updated_at;
            settings = _objectSpread(_objectSpread(_objectSpread({}, _builder.initialSettings), attributes.settings), {}, {
              name: attributes.name,
              type: attributes.type,
              language: attributes.language,
              rootId: rootId
            });
            dispatch(updateSettings(settings));

            // The way to get accommodation from app
            // const result1 = axios.get(Boilerplate.route('flow.accommodations', { flow: flowId }));
            if (!(pawnId !== 0 && responseSet !== 0)) {
              _context3.next = 33;
              break;
            }
            _context3.next = 30;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.player.entity.outline.content.pawn.index', {
              flow_id: flowId,
              pawn_id: pawnId,
              index: responseSet
            }));
          case 30:
            res = _context3.sent;
            _context3.next = 42;
            break;
          case 33:
            if (!(pawnId !== 0)) {
              _context3.next = 39;
              break;
            }
            _context3.next = 36;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.player.entity.outline.content.pawn', {
              flow_id: flowId,
              pawn_id: pawnId
            }));
          case 36:
            res = _context3.sent;
            _context3.next = 42;
            break;
          case 39:
            _context3.next = 41;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.player.entity.outline.content', {
              flow_id: flowId
            }));
          case 41:
            res = _context3.sent;
          case 42:
            stateUpdatedAt = (0, _get2["default"])(res, 'data.data.tree.state.updated_at', '0');
            treeUpdatedAt = (0, _get2["default"])(res, 'data.data.tree_updated_at', '0');
            dispatch(setList({
              pageFirstElementId: pageFirstElementId,
              tree: res.data.data.tree,
              elementTypes: _allElements["default"],
              withProgress: withProgress,
              startFromBeginning: flowUpdatedAt > stateUpdatedAt || treeUpdatedAt > stateUpdatedAt
            }));
            if (playingParentId) {
              dispatch(setPlayingParentId(playingParentId));
            }
            dispatch(setStartedProgress());

            // get metrics values
            dataConnectorsVariableIds = (0, _player.getDataConnectorsVariableIds)(getState().flow.player);
            if (!(dataConnectorsVariableIds.length > 0)) {
              _context3.next = 53;
              break;
            }
            _context3.next = 51;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), _objectSpread(_objectSpread(_objectSpread(_objectSpread({
              sourceId: flowId,
              sourceType: 'flow',
              values: '{}',
              variableIds: dataConnectorsVariableIds
            }, pawnId !== 0 && {
              pawnId: pawnId
            }), pawnId !== 0 && responseSet !== 0 && {
              responseSet: responseSet
            }), pawnId !== 0 && pawnHash !== '' && {
              pawnHash: pawnHash
            }), {}, {
              isPreviewMode: isPreviewMode
            }));
          case 51:
            _response = _context3.sent;
            dispatch(setMetricsValues(_response.data.data.variableValues));
          case 53:
            dispatch(unsetLoadingState());
          case 54:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};
function runAjax(_x7) {
  return _runAjax.apply(this, arguments);
}
function _runAjax() {
  _runAjax = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref8) {
    var run, dispatch, pageFirstElementId, id, result;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          run = _ref8.run, dispatch = _ref8.dispatch, pageFirstElementId = _ref8.pageFirstElementId;
          id = ajaxCount++;
          dispatch(addAjax({
            id: id,
            pageFirstElementId: pageFirstElementId
          }));
          _context14.prev = 3;
          _context14.next = 6;
          return run();
        case 6:
          result = _context14.sent;
          if (!(result !== noNetworkRequst && (result.status < 200 || result.status >= 300 || (0, _get2["default"])(result, 'data.status') !== 'success'))) {
            _context14.next = 11;
            break;
          }
          console.error('This is the result of wrong request:', JSON.stringify(result));
          (0, _browser.captureException)(new Error('Got wrong response when saving metrics or state'));
          throw new Error('There is no success response');
        case 11:
          dispatch(removeAjax(id));
          return _context14.abrupt("return", result);
        case 15:
          _context14.prev = 15;
          _context14.t0 = _context14["catch"](3);
          dispatch(showBadConnectionMessage(_context14.t0.response));
          return _context14.abrupt("return", Promise.reject(_context14.t0));
        case 19:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[3, 15]]);
  }));
  return _runAjax.apply(this, arguments);
}
var waitForResultSaved = exports.waitForResultSaved = function waitForResultSaved(dispatch, getState) {
  return new Promise(function (resolve) {
    var intervalId = setInterval(check, 200);
    check();
    function check() {
      var playerState = getState().flow.player;
      if ((0, _player.getHasUnfinishedAjax)(playerState)) {
        if (!playerState.waitingForAjax) {
          dispatch(setWaitingForAjax(true));
        }
      } else {
        clearInterval(intervalId);
        if (playerState.waitingForAjax) {
          dispatch(setWaitingForAjax(false));
        }
        resolve();
      }
    }
  });
};

// Just to not duplicate code
function getMetricsData(_ref9) {
  var answers = _ref9.answers,
    savedAnswers = _ref9.savedAnswers,
    list = _ref9.list,
    pageStartedTime = _ref9.pageStartedTime,
    flowId = _ref9.flowId,
    pawnId = _ref9.pawnId,
    pawnHash = _ref9.pawnHash,
    responseSet = _ref9.responseSet,
    pageElements = _ref9.pageElements,
    dynamicDataValues = _ref9.dynamicDataValues,
    settings = _ref9.settings,
    dataConnectorsVariableIds = _ref9.dataConnectorsVariableIds,
    includeOnlyDurationMetrics = _ref9.includeOnlyDurationMetrics;
  var metrics = {};
  var pawnValues = [];
  if (!includeOnlyDurationMetrics) {
    var getMetricsForElement = function getMetricsForElement(element) {
      var elementType = (0, _find2["default"])(_allElements["default"], {
        code: element.type
      });
      if (elementType && (0, _isFunction2["default"])(elementType.getMetrics)) {
        var elementMetrics = elementType.getMetrics(element.id, element.settings, answers[element.id]);
        (0, _forEach2["default"])(elementMetrics, function (value, name) {
          if ((0, _isObject2["default"])(value) && value.pawns) {
            value.pawns.forEach(function (pawnInfo) {
              var currentPawnValue = pawnValues.find(function (item) {
                return item.pawnId === pawnInfo.pawnId;
              });
              if (!currentPawnValue) {
                currentPawnValue = {
                  pawnId: pawnInfo.pawnId,
                  pawnHash: pawnInfo.pawnHash,
                  responseSet: responseSet,
                  values: {}
                };
                pawnValues.push(currentPawnValue);
              }
              currentPawnValue.values[name] = pawnInfo.value;
            });
          } else {
            metrics[name] = value;
          }
        });
      }
    };

    // Get updated answers
    (0, _forEach2["default"])(pageElements, function (element, key) {
      getMetricsForElement(element);
    });
    (0, _forEach2["default"])(answers, function (answer, key) {
      if (savedAnswers[key] && savedAnswers[key] === answer) {
        return;
      }
      getMetricsForElement(list[key]);
    });

    // Save app variables
    (settings.metricsVariables || []).forEach(function (name) {
      metrics["".concat(flowId, "_app_variable_").concat(name)] = dynamicDataValues[name] || null;
    });
  }

  // Get duration
  var duration = pageStartedTime != null ? (0, _helpers.getCurrentGmtTime)() - pageStartedTime : null;
  (0, _forEach2["default"])(pageElements, function (element) {
    metrics["".concat(element.id, "_duration")] = duration;
  });
  if (Object.keys(metrics).length === 0) {
    return null;
  }
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    sourceId: flowId,
    sourceType: 'flow',
    duration: duration,
    values: JSON.stringify(metrics)
  }, pawnValues.length > 0 && {
    pawnValues: pawnValues.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        values: JSON.stringify(item.values)
      });
    })
  }), {}, {
    variableIds: dataConnectorsVariableIds
  }, pawnId !== 0 && {
    pawnId: pawnId
  }), pawnId !== 0 && responseSet !== 0 && {
    responseSet: responseSet
  }), pawnId !== 0 && pawnHash !== '' && {
    pawnHash: pawnHash
  });
}

// Just to not duplicate code
function getProgressData(playerState) {
  var progress = playerState.progress,
    savedProgress = playerState.savedProgress,
    savedAnswers = playerState.savedAnswers,
    rootId = playerState.rootId,
    pageFirstElementId = playerState.pageFirstElementId,
    storage = playerState.storage,
    pageHistory = playerState.pageHistory;
  var updatedProgress = [];
  var answers = (0, _player.getAnswersToSave)(playerState);
  (0, _forEach2["default"])(answers, function (answer, key) {
    if (!savedAnswers[key] || savedAnswers[key] !== answer) {
      updatedProgress.push(_objectSpread({
        key: key,
        value: answer
      }, progress[key] && {
        progress: progress[key]
      }));
    }
  });
  (0, _forEach2["default"])(progress, function (obj, key) {
    if (!savedProgress[key] || !(0, _isEqual2["default"])(savedProgress[key], obj)) {
      if (!updatedProgress.find(function (item) {
        return item.key === key;
      })) {
        updatedProgress.push(_objectSpread({
          key: key,
          progress: obj
        }, answers[key] && {
          value: answers[key]
        }));
      }
    }
  });
  if (rootId !== 0) {
    updatedProgress.push({
      key: rootId.toString(),
      lastUnfinishedElement: pageFirstElementId,
      storage: storage,
      pageHistory: pageHistory
    });
  }
  if (updatedProgress.length === 0) {
    return null;
  }
  var data = {
    response_set: _objectSpread({}, (0, _player.getFlowStartedFinished)(playerState)),
    entity_states: updatedProgress.map(function (item) {
      var itemProgress = item.progress || {};
      var attributes = {
        // started_first: null,
        // finished_first: null,
        // started_last: '2017-03-19 13:09:33',
        // finished_last: '2017-03-19 13:09:33',
        entity_id: item.key,
        state: JSON.stringify((0, _omit2["default"])(item, ['key', 'progress']))
      };
      if (itemProgress.startedFirst) {
        attributes.started_first = itemProgress.startedFirst;
      }
      if (itemProgress.startedLast) {
        attributes.started_last = itemProgress.startedLast;
      }
      if (itemProgress.finishedFirst) {
        attributes.finished_first = itemProgress.finishedFirst;
      }
      if (itemProgress.finishedLast) {
        attributes.finished_last = itemProgress.finishedLast;
      }
      return {
        attributes: attributes
      };
    })
  };
  return data;
}

// Saves metrics and progress at the same time
var saveResult = exports.saveResult = function saveResult() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref10$loading = _ref10.loading,
    loading = _ref10$loading === void 0 ? false : _ref10$loading,
    _ref10$playerState = _ref10.playerState,
    playerState = _ref10$playerState === void 0 ? (0, _helpers.required)('playerState') : _ref10$playerState,
    pageElements = _ref10.pageElements,
    _ref10$includeMetrics = _ref10.includeMetrics,
    includeMetrics = _ref10$includeMetrics === void 0 ? true : _ref10$includeMetrics,
    _ref10$includeProgres = _ref10.includeProgress,
    includeProgress = _ref10$includeProgres === void 0 ? true : _ref10$includeProgres,
    _ref10$includeOnlyDur = _ref10.includeOnlyDurationMetrics,
    includeOnlyDurationMetrics = _ref10$includeOnlyDur === void 0 ? false : _ref10$includeOnlyDur;
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var flowId, pawnId, responseSet, pageFirstElementId, isPresenterMode, saveMetrics, _saveMetrics, saveProgress, _saveProgress;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _saveProgress = function _saveProgress3() {
              _saveProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                var data;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      data = getProgressData(getState().flow.player);
                      if (data) {
                        _context6.next = 3;
                        break;
                      }
                      return _context6.abrupt("return");
                    case 3:
                      dispatch(updateSavedProgress());
                      if (!(responseSet !== 0 && pawnId !== 0)) {
                        _context6.next = 11;
                        break;
                      }
                      data.response_set.pawn_id = pawnId;
                      data.response_set.index = responseSet;
                      _context6.next = 9;
                      return runAjax({
                        run: function run() {
                          return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findByAttr.entity.batch.store', {
                            flow_id: flowId
                          }), data);
                        },
                        dispatch: dispatch,
                        pageFirstElementId: pageFirstElementId
                      });
                    case 9:
                      _context6.next = 14;
                      break;
                    case 11:
                      if (pawnId !== 0) {
                        data.response_set.pawn_id = pawnId;
                      }
                      _context6.next = 14;
                      return runAjax({
                        run: function run() {
                          return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findById.entity.batch.store', {
                            flow_id: flowId,
                            response_set: 'latest'
                          }), data);
                        },
                        dispatch: dispatch,
                        pageFirstElementId: pageFirstElementId
                      });
                    case 14:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return _saveProgress.apply(this, arguments);
            };
            saveProgress = function _saveProgress2() {
              return _saveProgress.apply(this, arguments);
            };
            _saveMetrics = function _saveMetrics3() {
              _saveMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var dataConnectorsVariableIds, data;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      dataConnectorsVariableIds = (0, _player.getDataConnectorsVariableIds)(playerState);
                      if (includeOnlyDurationMetrics) {
                        data = getMetricsData(_objectSpread(_objectSpread({}, playerState), {}, {
                          pageElements: pageElements,
                          dataConnectorsVariableIds: dataConnectorsVariableIds,
                          includeOnlyDurationMetrics: true
                        }));
                      } else {
                        data = getMetricsData(_objectSpread(_objectSpread({}, playerState), {}, {
                          pageElements: pageElements,
                          dataConnectorsVariableIds: dataConnectorsVariableIds
                        }));
                        dispatch(updateSavedAnswers());
                      }
                      if (!data) {
                        _context5.next = 5;
                        break;
                      }
                      _context5.next = 5;
                      return runAjax({
                        run: function () {
                          var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                            var response;
                            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                              while (1) switch (_context4.prev = _context4.next) {
                                case 0:
                                  _context4.next = 2;
                                  return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), data);
                                case 2:
                                  response = _context4.sent;
                                  dispatch(setMetricsValues(response.data.data.variableValues));
                                  return _context4.abrupt("return", response);
                                case 5:
                                case "end":
                                  return _context4.stop();
                              }
                            }, _callee4);
                          }));
                          function run() {
                            return _run.apply(this, arguments);
                          }
                          return run;
                        }(),
                        dispatch: dispatch,
                        pageFirstElementId: pageFirstElementId
                      });
                    case 5:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              return _saveMetrics.apply(this, arguments);
            };
            saveMetrics = function _saveMetrics2() {
              return _saveMetrics.apply(this, arguments);
            };
            loading && dispatch(setLoadingState());
            flowId = playerState.flowId, pawnId = playerState.pawnId, responseSet = playerState.responseSet, pageFirstElementId = playerState.pageFirstElementId, isPresenterMode = playerState.isPresenterMode;
            pageElements = pageElements || (0, _player.getPageElements)(playerState);
            if (isPresenterMode) {
              _context7.next = 14;
              break;
            }
            if (!includeMetrics) {
              _context7.next = 11;
              break;
            }
            _context7.next = 11;
            return saveMetrics();
          case 11:
            if (!includeProgress) {
              _context7.next = 14;
              break;
            }
            _context7.next = 14;
            return saveProgress();
          case 14:
            loading && dispatch(unsetLoadingState());
          case 15:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x8, _x9) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var saveMetricsOnUnload = exports.saveMetricsOnUnload = function saveMetricsOnUnload() {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var playerState, flowId, pawnId, responseSet, hasBadConnection, waitingForAjax, saveProgress, currState;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            saveProgress = function _saveProgress4() {
              var progressData = getProgressData(playerState);
              if (!progressData) {
                return noNetworkRequst;
              }
              var data = _objectSpread(_objectSpread({}, progressData), {}, {
                _token: Boilerplate.settings.csrfToken
              });
              if (responseSet !== 0 && pawnId !== 0) {
                data.response_set.pawn_id = pawnId;
                data.response_set.index = responseSet;
                return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findByAttr.entity.batch.store', {
                  flow_id: flowId
                }), data, {
                  timeout: 15 * 1000
                });
              }
              if (pawnId !== 0) {
                data.response_set.pawn_id = pawnId;
              }
              return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findById.entity.batch.store', {
                flow_id: flowId,
                response_set: 'latest'
              }), data, {
                timeout: 15 * 1000
              });
            };
            // We'll just save progress here. Saving metrics are not necessary anymore
            playerState = getState().flow.player;
            flowId = playerState.flowId, pawnId = playerState.pawnId, responseSet = playerState.responseSet, hasBadConnection = playerState.hasBadConnection, waitingForAjax = playerState.waitingForAjax; // Don't save it if there were some bad connections
            if (!(hasBadConnection || waitingForAjax)) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return");
          case 5:
            currState = getState();
            _context8.next = 8;
            return runAjax({
              run: function run() {
                return saveProgress();
              },
              dispatch: dispatch,
              pageFirstElementId: currState.flow.player.pageFirstElementId
            });
          case 8:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x10, _x11) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var saveAndGoToNextPage = exports.saveAndGoToNextPage = function saveAndGoToNextPage(_ref13) {
  var isPreviewMode = _ref13.isPreviewMode,
    onComplete = _ref13.onComplete;
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState) {
      var playerState, _playerState, isPresenterMode, pageElements, _saveResult, hasPageFeedback, isFeedbackMode, waitForMetricsSaved;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            playerState = getState().flow.player;
            _playerState = playerState, isPresenterMode = _playerState.isPresenterMode;
            pageElements = (0, _player.getPageElements)(playerState);
            _saveResult = function _saveResult(args) {
              if (!isPreviewMode) {
                return dispatch(saveResult(_objectSpread(_objectSpread({}, args), {}, {
                  playerState: playerState
                })));
              }
            };
            hasPageFeedback = (0, _player.getHasPageFeedback)(playerState);
            isFeedbackMode = playerState.isFeedbackMode;
            _context9.next = 8;
            return waitForResultSaved(dispatch, getState);
          case 8:
            // Update player state. It could change from last time
            playerState = getState().flow.player;

            // Reset actions
            dispatch(resetActions());
            if (!((0, _player.isErrorOnThePage)(playerState) && !isPresenterMode)) {
              _context9.next = 14;
              break;
            }
            dispatch(setValidationErrors());
            _context9.next = 43;
            break;
          case 14:
            if (!(hasPageFeedback && !isFeedbackMode)) {
              _context9.next = 18;
              break;
            }
            // Show feedback
            dispatch(switchFeedbackMode(true));
            _context9.next = 43;
            break;
          case 18:
            if ((0, _player.isLastPage)(playerState)) {
              _context9.next = 37;
              break;
            }
            dispatch(setFinishedProgress());

            // Update player state
            playerState = getState().flow.player;
            waitForMetricsSaved = (0, _player.getWaitForMetricsSaved)(playerState);
            if (!waitForMetricsSaved) {
              _context9.next = 31;
              break;
            }
            _saveResult();
            _context9.next = 26;
            return waitForResultSaved(dispatch, getState);
          case 26:
            _context9.next = 28;
            return dispatch(preloadAndGoToNextPage());
          case 28:
            dispatch(setStartedProgress());
            _context9.next = 35;
            break;
          case 31:
            _context9.next = 33;
            return dispatch(preloadAndGoToNextPage());
          case 33:
            dispatch(setStartedProgress());
            _saveResult({
              pageElements: pageElements
            });
          case 35:
            _context9.next = 43;
            break;
          case 37:
            // Complete the flow
            dispatch(setFinishedProgress());
            dispatch(completeFlow());
            _saveResult();

            // wait for result saved before calling onComplete()
            _context9.next = 42;
            return waitForResultSaved(dispatch, getState);
          case 42:
            if (onComplete) {
              onComplete({
                showCompleteMessage: function showCompleteMessage() {
                  return dispatch(_showCompleteMessage());
                }
              });
            } else {
              dispatch(_showCompleteMessage());
            }
          case 43:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x12, _x13) {
      return _ref14.apply(this, arguments);
    };
  }();
};
var saveAndGoToPrevPage = exports.saveAndGoToPrevPage = function saveAndGoToPrevPage() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isPreviewMode = _ref15.isPreviewMode;
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState) {
      var playerState;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            playerState = getState().flow.player;
            _context10.next = 3;
            return waitForResultSaved(dispatch, getState);
          case 3:
            if (!isPreviewMode) {
              dispatch(saveResult({
                includeOnlyDurationMetrics: true,
                playerState: playerState
              }));
            }
            dispatch(goToPrevPage());
          case 5:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x14, _x15) {
      return _ref16.apply(this, arguments);
    };
  }();
};
var saveAndGoToComponent = exports.saveAndGoToComponent = function saveAndGoToComponent(_ref17) {
  var componentId = _ref17.componentId,
    isPreviewMode = _ref17.isPreviewMode;
  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(dispatch, getState) {
      var playerState;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            playerState = getState().flow.player;
            _context11.next = 3;
            return waitForResultSaved(dispatch, getState);
          case 3:
            dispatch(setFinishedProgress());
            dispatch(updatePageFirstElement(componentId));
            dispatch(setStartedProgress());
            if (!isPreviewMode) {
              dispatch(saveResult({
                includeOnlyDurationMetrics: true,
                playerState: playerState
              }));
            }
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x16, _x17) {
      return _ref18.apply(this, arguments);
    };
  }();
};
var saveStateAndMetrics = exports.saveStateAndMetrics = function saveStateAndMetrics() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isPreviewMode = _ref19.isPreviewMode,
    completeFlowIfLastPage = _ref19.completeFlowIfLastPage;
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(dispatch, getState) {
      var playerState, pageElements;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (!isPreviewMode) {
              _context12.next = 2;
              break;
            }
            return _context12.abrupt("return");
          case 2:
            playerState = getState().flow.player;
            pageElements = (0, _player.getPageElements)(playerState);
            _context12.next = 6;
            return waitForResultSaved(dispatch, getState);
          case 6:
            // Update player state. It could change from last time
            playerState = getState().flow.player;
            if (!(completeFlowIfLastPage && (0, _player.isLastPage)(playerState))) {
              _context12.next = 16;
              break;
            }
            // Complete the flow
            dispatch(setFinishedProgress());
            dispatch(completeFlow());
            _context12.next = 12;
            return dispatch(saveResult({
              playerState: playerState
            }));
          case 12:
            _context12.next = 14;
            return waitForResultSaved(dispatch, getState);
          case 14:
            _context12.next = 18;
            break;
          case 16:
            _context12.next = 18;
            return dispatch(saveResult({
              pageElements: pageElements,
              playerState: playerState
            }));
          case 18:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x18, _x19) {
      return _ref20.apply(this, arguments);
    };
  }();
};

// Blocks could filter or randomize children
var defineChildren = exports.defineChildren = function defineChildren() {
  return /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(dispatch, getState) {
      var playerState, answers;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            playerState = getState().flow.player;
            answers = [];
            Object.values(playerState.list).forEach(function (element) {
              var elementType = allElementsObject[element.type];
              if (!element.children || !elementType || !elementType.selectChildren) {
                return;
              }
              var selectedChildren = (0, _get2["default"])(playerState.answers, "".concat(element.id, ".selectedChildren"));
              var hasSelectedChildren = Boolean(selectedChildren);
              var needSelection = false;
              if (!Array.isArray(selectedChildren)) {
                needSelection = true;
              } else {
                // all selected children should still exist, otherwise we'll reselect
                needSelection = (0, _difference2["default"])(selectedChildren, element.children).length > 0;
              }
              if (needSelection) {
                selectedChildren = elementType.selectChildren(element.children, element.settings);
                if (Array.isArray(selectedChildren)) {
                  answers.push({
                    elementId: element.id,
                    answer: _objectSpread(_objectSpread({}, playerState.answers[element.id]), {}, {
                      selectedChildren: selectedChildren
                    })
                  });
                } else if (hasSelectedChildren) {
                  answers.push({
                    elementId: element.id,
                    answer: (0, _omit2["default"])(playerState.answers[element.id] || {}, ['selectedChildren'])
                  });
                }
              }
            });
            dispatch(updateAnswers(answers));
          case 4:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function (_x20, _x21) {
      return _ref21.apply(this, arguments);
    };
  }();
};

// Reducer
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), SET_WAITING_FOR_AJAX, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    waitingForAjax: action.payload
  });
}), RESET_ALL, function (state, action) {
  return _objectSpread(_objectSpread({}, initialState), {}, {
    isAudioReady: state.isAudioReady,
    enableAudio: state.enableAudio
  });
}), UPDATE_SETTINGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: action.payload
  });
}), SET_LIST, function (state, action) {
  var _action$payload = action.payload,
    tree = _action$payload.tree,
    elementTypes = _action$payload.elementTypes,
    withProgress = _action$payload.withProgress,
    startFromBeginning = _action$payload.startFromBeginning,
    pageFirstElementId = _action$payload.pageFirstElementId;
  var result = {};
  var answers = {};
  var progress = {};
  var rootId = +tree.id;
  var storage = {};
  var pageHistory = [];
  if (withProgress && tree.state && tree.state.state) {
    if (typeof pageFirstElementId !== 'number') {
      pageFirstElementId = startFromBeginning ? 0 : +tree.state.state.lastUnfinishedElement || 0;
    }
    storage = tree.state.state.storage || {};
    pageHistory = (tree.state.state.pageHistory || []).map(function (id) {
      return +id;
    });
  }
  if (typeof pageFirstElementId !== 'number') {
    pageFirstElementId = 0;
  }
  function getChildren(subtree) {
    subtree.forEach(function (item) {
      var elementType = (0, _find2["default"])(elementTypes, {
        code: item.type
      });
      if (!elementType) {
        throw new Error("Unknown type \"".concat(item.type, "\""));
      }
      var settings = item.content[0];
      if (withProgress && item.state) {
        if (item.state.state && item.state.state.value !== undefined) {
          answers[item.id] = item.state.state.value;
        }
        var itemProgress = {};
        if (item.state.started_first) {
          itemProgress.startedFirst = item.state.started_first;
        }
        if (item.state.started_last) {
          itemProgress.startedLast = item.state.started_last;
        }
        if (item.state.finished_first) {
          itemProgress.finishedFirst = item.state.finished_first;
        }
        if (item.state.finished_last) {
          itemProgress.finishedLast = item.state.finished_last;
        }
        if (!(0, _isEqual2["default"])(itemProgress, {})) {
          progress[item.id] = itemProgress;
        }
      }
      result[item.id] = _objectSpread({
        id: item.id,
        type: item.type,
        settings: settings.content
      }, (0, _pick2["default"])(elementType, ['skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage']));
      if (elementType.isAdult) {
        result[item.id].children = [];
      }
      if (item.children && item.children.length > 0) {
        result[item.id].children = item.children.map(function (child) {
          return child.id;
        });
        getChildren(item.children);
      }
    });
  }
  result[0] = {
    id: 0,
    children: tree.children.map(function (item) {
      return item.id;
    })
  };
  getChildren(tree.children);
  return _objectSpread(_objectSpread({}, state), {}, {
    pageFirstElementId: pageFirstElementId,
    list: result,
    rootId: rootId,
    answers: answers,
    savedAnswers: answers,
    progress: progress,
    savedProgress: progress,
    storage: storage,
    pageHistory: pageHistory
  });
}), UPDATE_ANSWER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    answers: _objectSpread(_objectSpread({}, state.answers), {}, _defineProperty({}, action.payload.elementId, action.payload.answer)),
    errors: (0, _omit2["default"])(state.errors, action.payload.elementId)
  });
}), UPDATE_ANSWERS, function (state, action) {
  if (action.payload.length === 0) {
    return state;
  }
  var newAnswers = _objectSpread({}, state.answers);
  var newErrors = _objectSpread({}, state.errors);
  action.payload.forEach(function (element) {
    newAnswers[element.elementId] = element.answer;
    delete newErrors[element.elementId];
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    answers: newAnswers,
    errors: newErrors
  });
}), RESET_ANSWERS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    answers: {},
    savedAnswers: {}
  });
}), SET_ANSWER_ERROR, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.payload.elementId, action.payload.message))
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, UPDATE_SAVED_ANSWERS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedAnswers: state.answers
  });
}), UPDATE_SAVED_PROGRESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedProgress: state.progress
  });
}), UPDATE_PAGE_FIRST_ELEMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pageHistory: [state.pageFirstElementId].concat(_toConsumableArray(state.pageHistory || [])),
    pageFirstElementId: action.payload,
    showValidationErrors: false
  });
}), SET_VALIDATION_ERRORS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showValidationErrors: state.showValidationErrors + 1
  });
}), GO_TO_NEXT_PAGE, function (state, action) {
  var nextElementId = (0, _player.getNextFirstElementId)(state);
  if (!nextElementId) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    pageHistory: [state.pageFirstElementId].concat(_toConsumableArray(state.pageHistory || [])),
    pageFirstElementId: nextElementId,
    showValidationErrors: false,
    actions: [],
    playingAction: [],
    isFeedbackMode: false
  });
}), GO_TO_PREV_PAGE, function (state, action) {
  var pageHistory = state.pageHistory,
    list = state.list;
  var sanitizedPageHistory = (0, _dropWhile2["default"])(pageHistory, function (id) {
    return !list[id];
  });
  if (sanitizedPageHistory.length === 0) {
    return state;
  }
  var _sanitizedPageHistory = _toArray(sanitizedPageHistory),
    nextId = _sanitizedPageHistory[0],
    newPageHistory = _sanitizedPageHistory.slice(1);
  return _objectSpread(_objectSpread({}, state), {}, {
    pageFirstElementId: nextId,
    pageHistory: newPageHistory,
    showValidationErrors: false,
    actions: [],
    playingAction: [],
    isFeedbackMode: false
  });
}), RESET_ACTIONS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    actions: [],
    playingAction: []
  });
}), COMPLETE_FLOW, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isCompleted: true
  });
}), SHOW_COMPLETE_MESSAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isCompleteMessage: true
  });
}), SET_PREVIEW_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    list: action.payload,
    answers: {},
    savedAnswers: {},
    progress: {},
    savedProgress: {},
    isCompleted: false,
    isCompleteMessage: false,
    pageFirstElementId: 0,
    pageHistory: [],
    showValidationErrors: false,
    actions: [],
    playingAction: [],
    storage: {},
    subscriptions: {},
    isFeedbackMode: false
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, REGISTER_ACTION, function (state, action) {
  if (!(0, _isFunction2["default"])(action.payload.play) || !(0, _isFunction2["default"])(action.payload.stop)) {
    console.error('Action has to return object with at least two methods: play() and stop()');
    return state;
  }
  var ids = state.actions.map(function (item) {
    return item.id;
  });
  var newId = ids.length > 0 ? (0, _max2["default"])(ids) + 1 : 1;
  return _objectSpread(_objectSpread({}, state), {}, {
    actions: [].concat(_toConsumableArray(state.actions), [_objectSpread({
      id: newId
    }, action.payload)])
  });
}), SET_PLAYING_PARENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    playingParentId: action.payload
  });
}), SET_PARAMETERS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    parameters: _objectSpread(_objectSpread({}, state.parameters), action.payload)
  });
}), SET_ACCOMMODATIONS, function (state, action) {
  var accommodations = action.payload;
  var knownAccommodations = ['masking', 'highlighting', 'autoplayQuestions', 'autoplayChoices', 'autoplayInstructions', 'blockUserInteractions'];
  var unknownAccommodations = (0, _keys2["default"])((0, _omit2["default"])(accommodations, knownAccommodations));
  if (unknownAccommodations.length > 0) {
    throw new Error("Unknown accommodations \"".concat(unknownAccommodations.join(', '), "\""));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    accommodations: accommodations
  });
}), SET_FLOW_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    flowId: action.payload
  });
}), SET_PAWN_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pawnId: action.payload
  });
}), SET_PAWN_HASH, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pawnHash: action.payload
  });
}), SET_RESPONSE_SET, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    responseSet: action.payload
  });
}), SET_STARTED_PROGRESS, function (state, action) {
  var startedProgress = (0, _filter2["default"])((0, _player.getProgress)(state), {
    progress: 'started'
  });
  var progress = (0, _cloneDeep2["default"])(state.progress);
  var date = (0, _helpers.getCurrentFormattedGmtTime)();
  startedProgress.forEach(function (item) {
    if (!progress[item.id]) {
      progress[item.id] = {};
    }
    if (!progress[item.id].startedFirst) {
      progress[item.id].startedFirst = date;
    }
    progress[item.id].startedLast = date;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    progress: progress
  });
}), SET_FINISHED_PROGRESS, function (state, action) {
  var finishedProgress = (0, _filter2["default"])((0, _player.getProgress)(state), {
    progress: 'finished'
  });
  var progress = (0, _cloneDeep2["default"])(state.progress);
  var date = (0, _helpers.getCurrentFormattedGmtTime)();
  finishedProgress.forEach(function (item) {
    if (!progress[item.id]) {
      progress[item.id] = {};
    }
    if (!progress[item.id].finishedFirst) {
      progress[item.id].finishedFirst = date;
    }
    progress[item.id].finishedLast = date;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    progress: progress
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_PAGE_STARTED_TIME, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pageStartedTime: action.payload
  });
}), SET_TO_STORAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    storage: _objectSpread(_objectSpread({}, state.storage), action.payload)
  });
}), ADD_SUBSCRIPTION, function (state, action) {
  var _action$payload2 = action.payload,
    token = _action$payload2.token,
    event = _action$payload2.event,
    callback = _action$payload2.callback;
  return _objectSpread(_objectSpread({}, state), {}, {
    subscriptions: _objectSpread(_objectSpread({}, state.subscriptions), {}, _defineProperty({}, token, {
      event: event,
      callback: callback
    }))
  });
}), DELETE_SUBSCRIPTION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    subscriptions: (0, _omit2["default"])(state.subscriptions, action.payload)
  });
}), SET_PLAYING_ACTION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    playingAction: [].concat(_toConsumableArray((0, _filter2["default"])(state.playingAction, function (item) {
      return item.id !== action.payload.id;
    })), [action.payload])
  });
}), UNSET_PLAYING_ACTION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    playingAction: (0, _filter2["default"])(state.playingAction, function (item) {
      return item.id !== action.payload;
    })
  });
}), SET_AUDIO_READY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isAudioReady: true
  });
}), ADD_AJAX, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    ajax: [].concat(_toConsumableArray(state.ajax), [action.payload])
  });
}), REMOVE_AJAX, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    ajax: state.ajax.filter(function (obj) {
      return obj.id !== action.payload;
    })
  });
}), SHOW_BAD_CONNECTION_MESSAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasBadConnection: true,
    badConnectionInfo: action.payload
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, START_FILE_PRELOAD_PROGRESS, function (state, action) {
  var preloadedUrls = state.preloadedAssets.map(function (asset) {
    return asset.url;
  });
  var newAssets = action.payload.filter(function (url) {
    return !preloadedUrls.includes(url);
  }).map(function (url) {
    return {
      url: url,
      status: 'inProgress',
      progress: 0
    };
  });
  if (newAssets.length === 0) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadedAssets: [].concat(_toConsumableArray(state.preloadedAssets), _toConsumableArray(newAssets))
  });
}), UPDATE_FILE_PRELOAD_PROGRESS, function (state, action) {
  var _action$payload3 = action.payload,
    url = _action$payload3.url,
    progress = _action$payload3.progress;
  var asset = _objectSpread(_objectSpread({}, state.preloadedAssets.find(function (item) {
    return item.url === url;
  })), {}, {
    url: url,
    progress: progress
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadedAssets: [].concat(_toConsumableArray(state.preloadedAssets.filter(function (item) {
      return item.url !== url;
    })), [asset])
  });
}), COMPLETE_FILE_PRELOAD, function (state, action) {
  var asset = _objectSpread(_objectSpread({}, state.preloadedAssets.find(function (item) {
    return item.url === action.payload;
  })), {}, {
    url: action.payload,
    status: 'done'
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadedAssets: [].concat(_toConsumableArray(state.preloadedAssets.filter(function (item) {
      return item.url !== action.payload;
    })), [asset])
  });
}), SET_PRELOADING_ASSETS_PROGRESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadingAssetsProgress: action.payload
  });
}), SET_DYNAMIC_DATA_VALUES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    dynamicDataValues: action.payload
  });
}), SET_DYNAMIC_USER_LISTS_VALUES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    dynamicUserListsValues: action.payload
  });
}), SET_METRICS_VALUES, function (state, action) {
  var values = action.payload;
  var variableIds = (0, _player.getDataConnectorsVariableIds)(state);
  var newValues = variableIds.reduce(function (obj, id) {
    if (values[id] || values[id] === 0) {
      obj[id] = "".concat(values[id]);
    }
    return obj;
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    metricsValues: newValues
  });
}), SET_ENABLE_AUDIO, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    enableAudio: Boolean(action.payload)
  });
}), SET_IS_PRESENTER_MODE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isPresenterMode: Boolean(action.payload)
  });
}), SWITCH_FEEDBACK_MODE, function (state, action) {
  if (state.isFeedbackMode === action.payload) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    isFeedbackMode: action.payload
  });
})), initialState);
var _default = exports["default"] = reducer;